var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "device flex-center",
      class: { active: _vm.switchstate === "on" ? "active" : "" },
      on: { click: _vm.toggleLight },
    },
    [
      _c("div", { staticClass: "text-c" }, [
        _c(
          "svg",
          {
            staticClass: "svg",
            attrs: {
              t: "1680502333905",
              viewBox: "0 0 1024 1024",
              version: "1.1",
              xmlns: "http://www.w3.org/2000/svg",
              "p-id": "7851",
              width: "48",
              height: "48",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M766.848 65.664H257.152c-104.874667 0-190.186667 85.312-190.186667 190.186667v512.298666c0 104.874667 85.312 190.186667 190.186667 190.186667h509.696c104.874667 0 190.186667-85.312 190.186667-190.186667V255.850667c0-104.853333-85.333333-190.186667-190.186667-190.186667z m157.141333 702.485333c0 86.656-70.485333 157.141333-157.141333 157.141334H257.152c-86.656 0-157.141333-70.485333-157.141333-157.141334V255.850667c0-86.656 70.485333-157.141333 157.141333-157.141334h509.696c86.656 0 157.141333 70.485333 157.141333 157.141334v512.298666z",
                "p-id": "7852",
                fill: "#999999",
              },
            }),
            _c("path", {
              attrs: {
                d: "M181.184 193.344m-15.104 0a15.104 15.104 0 1 0 30.208 0 15.104 15.104 0 1 0-30.208 0Z",
                "p-id": "7853",
                fill: "#999999",
              },
            }),
            _c("path", {
              attrs: {
                d: "M844.693333 193.344m-15.104 0a15.104 15.104 0 1 0 30.208 0 15.104 15.104 0 1 0-30.208 0Z",
                "p-id": "7854",
                fill: "#999999",
              },
            }),
            _c("path", {
              attrs: {
                d: "M844.693333 813.44m-15.104 0a15.104 15.104 0 1 0 30.208 0 15.104 15.104 0 1 0-30.208 0Z",
                "p-id": "7855",
                fill: "#999999",
              },
            }),
            _c("path", {
              attrs: {
                d: "M181.184 813.44m-15.104 0a15.104 15.104 0 1 0 30.208 0 15.104 15.104 0 1 0-30.208 0Z",
                "p-id": "7856",
                fill: "#999999",
              },
            }),
            _c("path", {
              attrs: {
                d: "M810.794667 382.528c-60.586667-30.890667-122.858667 5.226667-183.04 40.149333-13.76 7.978667-27.818667 15.893333-41.642667 23.082667-2.218667-2.624-4.416-5.248-6.869333-7.616a1028.053333 1028.053333 0 0 1 23.146666-41.877333c34.922667-60.202667 71.04-122.432 40.149334-183.04-23.168-45.461333-82.346667-61.674667-129.984-61.674667h-0.021334c-47.658667 0-106.837333 16.192-130.005333 61.674667-30.869333 60.608 5.226667 122.837333 40.128 183.018666 7.914667 13.632 15.68 27.541333 22.826667 41.28a99.413333 99.413333 0 0 0-7.082667 7.594667 1014.506667 1014.506667 0 0 1-42.176-23.509333c-60.202667-34.922667-122.453333-70.997333-183.018667-40.128-45.461333 23.168-61.674667 82.368-61.674666 130.005333s16.192 106.837333 61.674666 130.005333a105.6 105.6 0 0 0 48.768 11.690667c44.885333 0 90.133333-26.24 134.250667-51.84a1019.328 1019.328 0 0 1 41.706667-23.04c2.24 2.645333 4.458667 5.269333 6.954666 7.658667a1046.4 1046.4 0 0 1-23.274666 41.792c-34.922667 60.181333-71.018667 122.432-40.149334 183.04 23.168 45.461333 82.368 61.674667 130.005334 61.674666s106.837333-16.192 130.005333-61.674666c30.869333-60.608-5.226667-122.837333-40.149333-183.04a1070.506667 1070.506667 0 0 1-22.933334-41.173334c2.517333-2.389333 4.821333-4.928 7.104-7.573333 14.037333 7.253333 28.288 15.274667 42.261334 23.381333 44.138667 25.6 89.386667 51.84 134.272 51.84 16.32 0 32.597333-3.477333 48.768-11.690666 45.461333-23.168 61.674667-82.368 61.674666-130.005334s-16.213333-106.837333-61.674666-130.005333zM512 580.544c-36.117333 0-65.514667-30.762667-65.514667-68.565333s29.397333-68.565333 65.514667-68.565334c36.138667 0 65.536 30.762667 65.536 68.565334S548.138667 580.544 512 580.544z m-60.757333-200.896c-31.893333-54.954667-61.994667-106.858667-39.274667-151.445333 13.504-26.496 52.970667-43.626667 100.565333-43.626667h0.021334c47.573333 0 87.04 17.130667 100.544 43.626667 22.72 44.586667-7.381333 96.490667-39.274667 151.445333a1149.056 1149.056 0 0 0-21.994667 39.573333A95.274667 95.274667 0 0 0 512 410.389333c-13.866667 0-27.029333 3.029333-38.997333 8.384a1159.850667 1159.850667 0 0 0-21.76-39.125333z m-71.573334 193.109333c-54.976 31.893333-106.901333 61.994667-151.445333 39.274667-26.496-13.504-43.626667-52.970667-43.626667-100.565333s17.130667-87.061333 43.626667-100.565334c44.608-22.762667 96.490667 7.381333 151.424 39.274667 13.525333 7.850667 27.456 15.808 41.322667 23.061333A103.850667 103.850667 0 0 0 413.44 512c0 13.44 2.666667 26.24 7.296 37.994667-13.824 7.253333-27.605333 14.954667-41.066667 22.762666z m193.088 71.573334c31.872 54.954667 61.994667 106.858667 39.274667 151.445333-13.504 26.496-52.970667 43.626667-100.565333 43.626667s-87.061333-17.130667-100.565334-43.626667c-22.72-44.586667 7.402667-96.490667 39.296-151.445333 7.509333-12.949333 15.04-26.24 22.058667-39.530667a95.253333 95.253333 0 0 0 39.744 8.789333c13.824 0 26.965333-3.008 38.933333-8.341333 6.954667 13.141333 14.4 26.304 21.824 39.082667z m223.04-31.232c-44.629333 22.762667-96.490667-7.381333-151.445333-39.296a1127.402667 1127.402667 0 0 0-41.344-22.933334 103.253333 103.253333 0 0 0 0.277333-76.842666c13.802667-7.253333 27.605333-14.997333 41.045334-22.805334 54.976-31.872 106.816-61.994667 151.466666-39.274666 26.496 13.504 43.626667 52.970667 43.626667 100.565333s-17.130667 87.082667-43.626667 100.586667z",
                "p-id": "7857",
                fill: "#999999",
              },
            }),
          ]
        ),
        _c("p", { staticClass: "device-name" }, [
          _vm._v(_vm._s(_vm.deviceName)),
        ]),
        _c("div", { staticClass: "btn" }, [
          _vm.switchstate === "on"
            ? _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    fill: "none",
                    version: "1.1",
                    width: "80",
                    height: "80",
                    viewBox: "0 0 80 80",
                  },
                },
                [
                  _c(
                    "defs",
                    [
                      _c(
                        "linearGradient",
                        {
                          attrs: {
                            x1: "0.5",
                            y1: "-3.0616171314629196e-17",
                            x2: "0.5",
                            y2: "1",
                            id: "master_svg0_0_1320",
                          },
                        },
                        [
                          _c("stop", {
                            attrs: {
                              offset: "0%",
                              "stop-color": "#000000",
                              "stop-opacity": "1",
                            },
                          }),
                          _c("stop", {
                            attrs: {
                              offset: "100%",
                              "stop-color": "#000000",
                              "stop-opacity": "1",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "linearGradient",
                        {
                          attrs: {
                            x1: "0.5",
                            y1: "-3.0616171314629196e-17",
                            x2: "0.5",
                            y2: "1",
                            id: "master_svg1_0_1322",
                          },
                        },
                        [
                          _c("stop", {
                            attrs: {
                              offset: "0%",
                              "stop-color": "#000000",
                              "stop-opacity": "0.6299999952316284",
                            },
                          }),
                          _c("stop", {
                            attrs: {
                              offset: "100%",
                              "stop-color": "#4A4848",
                              "stop-opacity": "1",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "linearGradient",
                        {
                          attrs: {
                            x1: "0.5",
                            y1: "-3.0616171314629196e-17",
                            x2: "0.5",
                            y2: "1",
                            id: "master_svg2_0_1325",
                          },
                        },
                        [
                          _c("stop", {
                            attrs: {
                              offset: "0%",
                              "stop-color": "#38393E",
                              "stop-opacity": "1",
                            },
                          }),
                          _c("stop", {
                            attrs: {
                              offset: "22.69131988286972%",
                              "stop-color": "#38393E",
                              "stop-opacity": "1",
                            },
                          }),
                          _c("stop", {
                            attrs: {
                              offset: "100%",
                              "stop-color": "#18191D",
                              "stop-opacity": "1",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "filter",
                        {
                          attrs: {
                            id: "master_svg3_0_6835",
                            filterUnits: "objectBoundingBox",
                            "color-interpolation-filters": "sRGB",
                            x: "-4",
                            y: "-5",
                            width: "33.64571571350098",
                            height: "34.40000343322754",
                          },
                        },
                        [
                          _c("feFlood", {
                            attrs: {
                              "flood-opacity": "0",
                              result: "BackgroundImageFix",
                            },
                          }),
                          _c("feColorMatrix", {
                            attrs: {
                              in: "SourceAlpha",
                              type: "matrix",
                              values:
                                "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            },
                          }),
                          _c("feOffset", { attrs: { dy: "-1", dx: "0" } }),
                          _c("feGaussianBlur", {
                            attrs: { stdDeviation: "1" },
                          }),
                          _c("feColorMatrix", {
                            attrs: {
                              type: "matrix",
                              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0",
                            },
                          }),
                          _c("feBlend", {
                            attrs: {
                              mode: "normal",
                              in2: "BackgroundImageFix",
                              result: "effect1_dropShadow",
                            },
                          }),
                          _c("feBlend", {
                            attrs: {
                              mode: "normal",
                              in: "SourceGraphic",
                              in2: "effect1_dropShadow",
                              result: "shape",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "g",
                    { staticStyle: { "mix-blend-mode": "passthrough" } },
                    [
                      _c(
                        "g",
                        { staticStyle: { "mix-blend-mode": "passthrough" } },
                        [
                          _c(
                            "g",
                            {
                              staticStyle: { "mix-blend-mode": "passthrough" },
                            },
                            [
                              _c("ellipse", {
                                attrs: {
                                  cx: "39.999999046325684",
                                  cy: "39.999999046325684",
                                  rx: "30.399999618530273",
                                  ry: "30.399999618530273",
                                  fill: "url(#master_svg0_0_1320)",
                                  "fill-opacity": "0.20000000298023224",
                                },
                              }),
                              _c("ellipse", {
                                attrs: {
                                  cx: "39.999999046325684",
                                  cy: "39.999999046325684",
                                  rx: "31.399999618530273",
                                  ry: "31.399999618530273",
                                  stroke: "url(#master_svg1_0_1322)",
                                  "fill-opacity": "0",
                                  fill: "none",
                                  "stroke-width": "2",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "g",
                            {
                              staticStyle: { "mix-blend-mode": "passthrough" },
                            },
                            [
                              _c("ellipse", {
                                attrs: {
                                  cx: "39.99999666213989",
                                  cy: "39.99999666213989",
                                  rx: "28.799997329711914",
                                  ry: "28.799997329711914",
                                  fill: "url(#master_svg2_0_1325)",
                                  "fill-opacity": "1",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "g",
                            {
                              staticStyle: { "mix-blend-mode": "passthrough" },
                              attrs: { filter: "url(#master_svg3_0_6835)" },
                            },
                            [
                              _c(
                                "g",
                                {
                                  staticStyle: {
                                    "mix-blend-mode": "passthrough",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M32.87056866485596,28.835752230682374C29.005218664855956,31.044347230682373,26.399998664855957,35.20650723068238,26.399998664855957,39.977137230682374C26.399998664855957,47.05903723068238,32.14098866485595,52.80003723068238,39.22289866485596,52.80003723068238C46.304698664855955,52.80003723068238,52.04569866485596,47.05903723068238,52.04569866485596,39.977137230682374C52.04569866485596,35.54540723068237,49.79749866485596,31.638777230682372,46.379398664855955,29.335537230682373C45.88699866485595,29.003762230682373,45.25709866485596,29.366297230682374,45.25709866485596,29.96002723068237C45.25709866485596,29.965807230682373,45.25709866485596,29.971567230682375,45.25709866485596,29.977277230682372C45.25709866485596,30.24698723068237,45.395898664855956,30.489807230682374,45.61819866485595,30.64244723068237C48.58879866485596,32.68154723068237,50.53709866485596,36.10181723068237,50.53709866485596,39.977137230682374C50.53709866485596,46.22583723068237,45.47159866485596,51.29143723068238,39.22289866485596,51.29143723068238C32.97414866485596,51.29143723068238,27.908568664855956,46.22583723068237,27.908568664855956,39.977137230682374C27.908568664855956,35.80229723068237,30.169728664855956,32.15556723068237,33.534168664855954,30.19481723068237C33.78402866485596,30.049207230682374,33.942858664855954,29.795257230682374,33.942858664855954,29.506067230682373C33.942858664855954,29.502267230682374,33.942858664855954,29.498457230682373,33.942858664855954,29.494637230682372C33.942858664855954,28.927767230682374,33.362768664855956,28.554521230682372,32.87056866485596,28.835752230682374",
                                      "fill-rule": "evenodd",
                                      fill: "#F2BC53",
                                      "fill-opacity": "1",
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "g",
                                {
                                  staticStyle: {
                                    "mix-blend-mode": "passthrough",
                                  },
                                },
                                [
                                  _c("rect", {
                                    attrs: {
                                      x: "38.46857166290283",
                                      y: "26.399998664855957",
                                      width: "1.5085703134536743",
                                      height: "7.5428595542907715",
                                      rx: "0.7542851567268372",
                                      fill: "#F2BC53",
                                      "fill-opacity": "1",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            : _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    fill: "none",
                    version: "1.1",
                    width: "80",
                    height: "80",
                    viewBox: "0 0 80 80",
                  },
                },
                [
                  _c(
                    "defs",
                    [
                      _c(
                        "linearGradient",
                        {
                          attrs: {
                            x1: "0.5",
                            y1: "-3.0616171314629196e-17",
                            x2: "0.5",
                            y2: "1",
                            id: "master_svg0_0_1320",
                          },
                        },
                        [
                          _c("stop", {
                            attrs: {
                              offset: "0%",
                              "stop-color": "#000000",
                              "stop-opacity": "1",
                            },
                          }),
                          _c("stop", {
                            attrs: {
                              offset: "100%",
                              "stop-color": "#000000",
                              "stop-opacity": "1",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "linearGradient",
                        {
                          attrs: {
                            x1: "0.5",
                            y1: "-3.0616171314629196e-17",
                            x2: "0.5",
                            y2: "1",
                            id: "master_svg1_0_1322",
                          },
                        },
                        [
                          _c("stop", {
                            attrs: {
                              offset: "0%",
                              "stop-color": "#000000",
                              "stop-opacity": "0.6299999952316284",
                            },
                          }),
                          _c("stop", {
                            attrs: {
                              offset: "100%",
                              "stop-color": "#4A4848",
                              "stop-opacity": "1",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "linearGradient",
                        {
                          attrs: {
                            x1: "0.5",
                            y1: "-3.0616171314629196e-17",
                            x2: "0.5",
                            y2: "1",
                            id: "master_svg2_0_1325",
                          },
                        },
                        [
                          _c("stop", {
                            attrs: {
                              offset: "0%",
                              "stop-color": "#38393E",
                              "stop-opacity": "1",
                            },
                          }),
                          _c("stop", {
                            attrs: {
                              offset: "22.69131988286972%",
                              "stop-color": "#38393E",
                              "stop-opacity": "1",
                            },
                          }),
                          _c("stop", {
                            attrs: {
                              offset: "100%",
                              "stop-color": "#18191D",
                              "stop-opacity": "1",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "filter",
                        {
                          attrs: {
                            id: "master_svg3_0_6748",
                            filterUnits: "objectBoundingBox",
                            "color-interpolation-filters": "sRGB",
                            x: "-4",
                            y: "-5",
                            width: "33.64571571350098",
                            height: "34.40000343322754",
                          },
                        },
                        [
                          _c("feFlood", {
                            attrs: {
                              "flood-opacity": "0",
                              result: "BackgroundImageFix",
                            },
                          }),
                          _c("feColorMatrix", {
                            attrs: {
                              in: "SourceAlpha",
                              type: "matrix",
                              values:
                                "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                            },
                          }),
                          _c("feOffset", { attrs: { dy: "-1", dx: "0" } }),
                          _c("feGaussianBlur", {
                            attrs: { stdDeviation: "1" },
                          }),
                          _c("feColorMatrix", {
                            attrs: {
                              type: "matrix",
                              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0",
                            },
                          }),
                          _c("feBlend", {
                            attrs: {
                              mode: "normal",
                              in2: "BackgroundImageFix",
                              result: "effect1_dropShadow",
                            },
                          }),
                          _c("feBlend", {
                            attrs: {
                              mode: "normal",
                              in: "SourceGraphic",
                              in2: "effect1_dropShadow",
                              result: "shape",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "g",
                    { staticStyle: { "mix-blend-mode": "passthrough" } },
                    [
                      _c(
                        "g",
                        { staticStyle: { "mix-blend-mode": "passthrough" } },
                        [
                          _c(
                            "g",
                            {
                              staticStyle: {
                                opacity: "0.5",
                                "mix-blend-mode": "passthrough",
                              },
                            },
                            [
                              _c("ellipse", {
                                attrs: {
                                  cx: "39.999999046325684",
                                  cy: "39.999999046325684",
                                  rx: "30.399999618530273",
                                  ry: "30.399999618530273",
                                  fill: "url(#master_svg0_0_1320)",
                                  "fill-opacity": "0.20000000298023224",
                                },
                              }),
                              _c("ellipse", {
                                attrs: {
                                  cx: "39.999999046325684",
                                  cy: "39.999999046325684",
                                  rx: "31.399999618530273",
                                  ry: "31.399999618530273",
                                  stroke: "url(#master_svg1_0_1322)",
                                  "fill-opacity": "0",
                                  fill: "none",
                                  "stroke-width": "2",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "g",
                            {
                              staticStyle: { "mix-blend-mode": "passthrough" },
                            },
                            [
                              _c("ellipse", {
                                attrs: {
                                  cx: "39.99999666213989",
                                  cy: "39.99999666213989",
                                  rx: "28.799997329711914",
                                  ry: "28.799997329711914",
                                  fill: "url(#master_svg2_0_1325)",
                                  "fill-opacity": "1",
                                },
                              }),
                            ]
                          ),
                          _c(
                            "g",
                            {
                              staticStyle: { "mix-blend-mode": "passthrough" },
                              attrs: { filter: "url(#master_svg3_0_6748)" },
                            },
                            [
                              _c(
                                "g",
                                {
                                  staticStyle: {
                                    "mix-blend-mode": "passthrough",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M32.87056866485596,28.835752230682374C29.005218664855956,31.044347230682373,26.399998664855957,35.20650723068238,26.399998664855957,39.977137230682374C26.399998664855957,47.05903723068238,32.14098866485595,52.80003723068238,39.22289866485596,52.80003723068238C46.304698664855955,52.80003723068238,52.04569866485596,47.05903723068238,52.04569866485596,39.977137230682374C52.04569866485596,35.54540723068237,49.79749866485596,31.638777230682372,46.379398664855955,29.335537230682373C45.88699866485595,29.003762230682373,45.25709866485596,29.366297230682374,45.25709866485596,29.96002723068237C45.25709866485596,29.965807230682373,45.25709866485596,29.971567230682375,45.25709866485596,29.977277230682372C45.25709866485596,30.24698723068237,45.395898664855956,30.489807230682374,45.61819866485595,30.64244723068237C48.58879866485596,32.68154723068237,50.53709866485596,36.10181723068237,50.53709866485596,39.977137230682374C50.53709866485596,46.22583723068237,45.47159866485596,51.29143723068238,39.22289866485596,51.29143723068238C32.97414866485596,51.29143723068238,27.908568664855956,46.22583723068237,27.908568664855956,39.977137230682374C27.908568664855956,35.80229723068237,30.169728664855956,32.15556723068237,33.534168664855954,30.19481723068237C33.78402866485596,30.049207230682374,33.942858664855954,29.795257230682374,33.942858664855954,29.506067230682373C33.942858664855954,29.502267230682374,33.942858664855954,29.498457230682373,33.942858664855954,29.494637230682372C33.942858664855954,28.927767230682374,33.362768664855956,28.554521230682372,32.87056866485596,28.835752230682374",
                                      "fill-rule": "evenodd",
                                      fill: "#999999",
                                      "fill-opacity": "0.6000000238418579",
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "g",
                                {
                                  staticStyle: {
                                    "mix-blend-mode": "passthrough",
                                  },
                                },
                                [
                                  _c("rect", {
                                    attrs: {
                                      x: "38.46857166290283",
                                      y: "26.399998664855957",
                                      width: "1.5085703134536743",
                                      height: "7.5428595542907715",
                                      rx: "0.7542851567268372",
                                      fill: "#999999",
                                      "fill-opacity": "0.6000000238418579",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }